module.exports = __webpack_public_path__ + "img/w3_trash_recover_white.4e1cb330.png";